module.exports = " <button class=weui_btn :class=classes :disabled=disabled> {{text}}<slot></slot> </button> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/x-button/index.vue
// module id = 262
// module chunks = 2